import API from 'services/api';

export interface IGuestMisconductCategory {
  id: number;
  parentId: number | null;
  name: string;
  isPropertyDamage: boolean;
}

export interface IGuestMisconductDamageType {
  id: number;
  name: string;
}

export interface IGuestMisconductFormData {
  categories: IGuestMisconductCategory[];
  damageTypes: IGuestMisconductDamageType[];
}

export const getGuestMisconductFormData = (): Promise<IGuestMisconductFormData> =>
  API.get('/api/accommodation/calculations/booking/reporting/guest-misconduct/form-data').then(
    response => response?.data,
  );
